export default "__VITE_ASSET__7b1b68c9__"